import * as fmt from "../operations/formats";

export function setFormat(row, column, format){
	fmt.addFormat(this, row, column, format);
}

export function changeDecimals(row, column, inc){
	//row and column may be obj
	fmt.changeAreaDecimals(this, inc, row, column);
}